import React from 'react';
import './List.css';

function ListTextItem({children, isHeader = false, type = 0, size = 'big'}) {
  return (
    <div className={"listTextContainer"}>
      <div className={`${isHeader ? `header` : `normal`} ${type === 1 ? "accent" : type === 2 ? "positive" : type === 'primary' ? "primary" : type === 'secondary' ? "secondary" : type === 'meta' ? "meta" : "text"} ${size}`}>
        {children}
      </div>
    </div>
  )
}

export default ListTextItem